export default __webpack_public_path__ + "static/media/avatar-men.34b54918.png";